// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml,<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 100 100\"><defs><pattern id=\"grid\" width=\"10\" height=\"10\" patternUnits=\"userSpaceOnUse\"><path d=\"M 10 0 L 0 0 0 10\" fill=\"none\" stroke=\"rgba%28255,255,255,0.05%29\" stroke-width=\"0.5\"/></pattern></defs><rect width=\"100\" height=\"100\" fill=\"url%28%23grid%29\"/></svg>", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Reset and Base Styles */
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

:root {
  /* Color Palette */
  --primary-blue: #0f172a;
  --secondary-blue: #1e293b;
  --accent-blue: #3b82f6;
  --light-blue: #60a5fa;
  --teal: #14b8a6;
  --light-teal: #5eead4;
  --white: #ffffff;
  --gray-50: #f8fafc;
  --gray-100: #f1f5f9;
  --gray-200: #e2e8f0;
  --gray-300: #cbd5e1;
  --gray-600: #475569;
  --gray-700: #334155;
  --gray-800: #1e293b;
  --gray-900: #0f172a;
  
  /* Typography */
  --font-primary: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
  --font-mono: 'JetBrains Mono', 'Fira Code', monospace;
  
  /* Spacing */
  --space-xs: 0.5rem;
  --space-sm: 1rem;
  --space-md: 1.5rem;
  --space-lg: 2rem;
  --space-xl: 3rem;
  --space-2xl: 4rem;
  
  /* Shadows */
  --shadow-sm: 0 1px 2px 0 rgb(0 0 0 / 0.05);
  --shadow-md: 0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1);
  --shadow-lg: 0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1);
  --shadow-xl: 0 20px 25px -5px rgb(0 0 0 / 0.1), 0 8px 10px -6px rgb(0 0 0 / 0.1);
  
  /* Border Radius */
  --radius-sm: 0.375rem;
  --radius-md: 0.5rem;
  --radius-lg: 0.75rem;
  --radius-xl: 1rem;
  --radius-2xl: 1.5rem;
}

/* Import Google Fonts */

.App {
  font-family: var(--font-primary);
  line-height: 1.6;
  color: var(--gray-700);
  background: linear-gradient(135deg, var(--gray-50) 0%, var(--white) 50%, var(--gray-100) 100%);
  min-height: 100vh;
  margin: 0;
  padding: 0;
  overflow-x: hidden;
}

/* Main Content */
main {
  margin-top: 80px;
  padding: 0;
  min-height: calc(100vh - 80px);
}

/* Common Section Styles */
.hero-section {
  background: linear-gradient(135deg, var(--primary-blue) 0%, var(--secondary-blue) 100%);
  color: var(--white);
  padding: var(--space-2xl) var(--space-lg);
  text-align: center;
  position: relative;
  overflow: hidden;
}

.hero-section::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  opacity: 0.3;
}

.hero-content {
  max-width: 800px;
  margin: 0 auto;
  position: relative;
  z-index: 1;
}

.hero-title {
  font-size: 3.5rem;
  font-weight: 800;
  margin-bottom: var(--space-lg);
  background: linear-gradient(135deg, var(--white) 0%, var(--light-teal) 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  line-height: 1.1;
}

.hero-subtitle {
  font-size: 1.25rem;
  margin-bottom: var(--space-xl);
  color: var(--gray-300);
  font-weight: 400;
}

.hero-cta {
  display: flex;
  gap: var(--space-md);
  justify-content: center;
  flex-wrap: wrap;
  margin-top: var(--space-xl);
}

.hero-cta .cta-button {
  font-size: 1.1rem;
  padding: var(--space-md) var(--space-xl);
}

.hero-cta .cta-button.secondary {
  background: transparent;
  border: 2px solid var(--white);
  color: var(--white);
}

.hero-cta .cta-button.secondary:hover {
  background: var(--white);
  color: var(--primary-blue);
}

/* Services Section */
.services-section {
  padding: var(--space-2xl) var(--space-lg);
  background: var(--white);
}

.services-container {
  max-width: 1200px;
  margin: 0 auto;
}

.section-title {
  text-align: center;
  font-size: 2.5rem;
  font-weight: 700;
  color: var(--gray-900);
  margin-bottom: var(--space-lg);
}

.section-subtitle {
  text-align: center;
  font-size: 1.1rem;
  color: var(--gray-600);
  margin-bottom: var(--space-2xl);
  max-width: 600px;
  margin-left: auto;
  margin-right: auto;
}

.services-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: var(--space-xl);
  margin-top: var(--space-2xl);
}

.service-card {
  background: var(--white);
  border: 1px solid var(--gray-200);
  border-radius: var(--radius-xl);
  padding: var(--space-xl);
  text-align: center;
  transition: all 0.3s ease;
  box-shadow: var(--shadow-sm);
  position: relative;
  overflow: hidden;
}

.service-card::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 4px;
  background: linear-gradient(135deg, var(--accent-blue) 0%, var(--teal) 100%);
  transform: scaleX(0);
  transition: transform 0.3s ease;
}

.service-card:hover {
  transform: translateY(-8px);
  box-shadow: var(--shadow-xl);
  border-color: var(--accent-blue);
}

.service-card:hover::before {
  transform: scaleX(1);
}

.service-icon {
  font-size: 3rem;
  margin-bottom: var(--space-lg);
  display: block;
}

.service-card h3 {
  font-size: 1.5rem;
  font-weight: 600;
  color: var(--gray-900);
  margin-bottom: var(--space-md);
}

.service-card p {
  color: var(--gray-600);
  line-height: 1.6;
  margin: 0;
}

/* Features Section */
.features-section {
  padding: var(--space-2xl) var(--space-lg);
  background: var(--gray-50);
}

.features-container {
  max-width: 1200px;
  margin: 0 auto;
}

.features-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: var(--space-xl);
  max-width: 1200px;
  margin: 0 auto;
}

.feature-item {
  display: flex;
  gap: var(--space-md);
  align-items: flex-start;
}

.feature-icon {
  width: 48px;
  height: 48px;
  background: linear-gradient(135deg, var(--accent-blue) 0%, var(--teal) 100%);
  border-radius: var(--radius-lg);
  display: flex;
  align-items: center;
  justify-content: center;
  color: var(--white);
  font-size: 1.5rem;
  flex-shrink: 0;
}

.feature-content h4 {
  font-size: 1.25rem;
  font-weight: 600;
  color: var(--gray-900);
  margin-bottom: var(--space-xs);
}

.feature-content p {
  color: var(--gray-600);
  line-height: 1.6;
  margin: 0;
}

/* CTA Section */
.cta-section {
  padding: var(--space-2xl) var(--space-lg);
  background: linear-gradient(135deg, var(--accent-blue) 0%, var(--teal) 100%);
  color: var(--white);
  text-align: center;
}

.cta-content {
  max-width: 600px;
  margin: 0 auto;
}

.cta-content h2 {
  font-size: 2.5rem;
  font-weight: 700;
  margin-bottom: var(--space-lg);
}

.cta-content p {
  font-size: 1.1rem;
  margin-bottom: var(--space-xl);
  opacity: 0.9;
}

.cta-content .cta-button {
  background: var(--white);
  color: var(--accent-blue);
  font-size: 1.1rem;
  padding: var(--space-md) var(--space-xl);
}

.cta-content .cta-button:hover {
  background: var(--gray-100);
  color: var(--accent-blue);
}

/* CTA Button */
.cta-button {
  background: linear-gradient(135deg, var(--accent-blue) 0%, var(--teal) 100%);
  color: var(--white);
  padding: var(--space-sm) var(--space-lg);
  border-radius: var(--radius-lg);
  text-decoration: none;
  font-weight: 600;
  font-size: 0.9rem;
  transition: all 0.3s ease;
  box-shadow: var(--shadow-md);
  border: none;
  cursor: pointer;
  display: inline-block;
}

.cta-button:hover {
  transform: translateY(-2px);
  box-shadow: var(--shadow-lg);
  color: var(--white);
}

/* Responsive Design */
@media (max-width: 768px) {
  .hero-title {
    font-size: 2.5rem;
  }
  
  .hero-subtitle {
    font-size: 1.1rem;
  }
  
  .hero-cta {
    flex-direction: column;
    align-items: center;
  }
  
  .section-title {
    font-size: 2rem;
  }
  
  .services-grid {
    grid-template-columns: 1fr;
    gap: var(--space-lg);
  }
  
  .features-grid {
    grid-template-columns: 1fr;
  }
}

@media (max-width: 480px) {
  .hero-section {
    padding: var(--space-xl) var(--space-md);
  }
  
  .hero-title {
    font-size: 2rem;
  }
  
  .services-section,
  .features-section,
  .cta-section {
    padding: var(--space-xl) var(--space-md);
  }
  
  .service-card {
    padding: var(--space-lg);
  }
}

.hero-eyebrow {
  display: inline-block;
  font-size: 0.85rem;
  font-weight: 600;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: var(--light-teal);
  margin-bottom: var(--space-md);
}

.hero-trust-list {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: var(--space-md);
  margin-top: var(--space-xl);
  color: var(--gray-300);
  font-size: 0.95rem;
}

.hero-trust-list span {
  display: inline-flex;
  align-items: center;
  gap: 0.4rem;
}

.hero-trust-icon {
  width: 18px;
  height: 18px;
  color: var(--light-teal);
}

.trust-bar {
  background: var(--white);
  border-bottom: 1px solid var(--gray-200);
  padding: var(--space-lg);
}

.trust-bar-container {
  max-width: 1200px;
  margin: 0 auto;
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: var(--space-lg);
  text-align: center;
}

.trust-stat strong {
  display: block;
  font-size: 1.5rem;
  font-weight: 700;
  color: var(--gray-900);
  margin-bottom: var(--space-xs);
}

.trust-stat span {
  color: var(--gray-600);
  font-size: 0.9rem;
}

.icon-box {
  width: 56px;
  height: 56px;
  background: linear-gradient(135deg, var(--accent-blue) 0%, var(--teal) 100%);
  border-radius: var(--radius-lg);
  display: flex;
  align-items: center;
  justify-content: center;
  color: var(--white);
  margin: 0 auto var(--space-lg) auto;
  flex-shrink: 0;
}

.feature-item .icon-box {
  margin: 0;
}

.icon-svg {
  display: block;
}

.icon-box .icon-svg {
  width: 28px;
  height: 28px;
}

.audience-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: var(--space-xl);
  margin-top: var(--space-2xl);
}

.audience-card {
  background: var(--gray-50);
  border: 1px solid var(--gray-200);
  border-radius: var(--radius-xl);
  padding: var(--space-xl);
}

.audience-card h3 {
  font-size: 1.25rem;
  font-weight: 600;
  color: var(--gray-900);
  margin-bottom: var(--space-sm);
}

.audience-card p {
  color: var(--gray-600);
  line-height: 1.6;
}

.process-section {
  padding: var(--space-2xl) var(--space-lg);
  background: var(--gray-50);
}

.process-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: var(--space-xl);
  margin-top: var(--space-2xl);
}

.process-step {
  text-align: center;
  padding: var(--space-xl);
  background: var(--white);
  border: 1px solid var(--gray-200);
  border-radius: var(--radius-lg);
}

.step-number {
  width: 60px;
  height: 60px;
  background: linear-gradient(135deg, var(--accent-blue) 0%, var(--teal) 100%);
  color: var(--white);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.5rem;
  font-weight: 700;
  margin: 0 auto var(--space-md) auto;
}

.process-step h4 {
  font-size: 1.2rem;
  font-weight: 600;
  color: var(--gray-900);
  margin-bottom: var(--space-sm);
}

.about-grid {
  display: grid;
  grid-template-columns: 2fr 1fr;
  gap: var(--space-2xl);
}

.about-text h3 {
  font-size: 1.5rem;
  font-weight: 600;
  color: var(--gray-900);
  margin-bottom: var(--space-sm);
  margin-top: var(--space-xl);
}

.about-text h3:first-child {
  margin-top: 0;
}

.about-features {
  list-style: none;
  padding: 0;
}

.about-features li {
  padding: var(--space-xs) 0;
  color: var(--gray-600);
  position: relative;
  padding-left: var(--space-lg);
}

.about-features li::before {
  content: '✓';
  position: absolute;
  left: 0;
  color: var(--teal);
  font-weight: bold;
}

.about-stats {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: var(--space-lg);
}

.stat-item {
  text-align: center;
  padding: var(--space-lg);
  background: var(--white);
  border: 1px solid var(--gray-200);
  border-radius: var(--radius-lg);
}

.stat-number {
  font-size: 2rem;
  font-weight: 700;
  color: var(--accent-blue);
}

.stat-label {
  font-size: 0.9rem;
  color: var(--gray-600);
}

.footer-cta-button {
  display: inline-block;
  margin-top: var(--space-sm);
  font-size: 0.9rem;
  padding: var(--space-sm) var(--space-md);
}

.footer-contact a {
  color: var(--light-teal);
  text-decoration: none;
}

.footer-legal {
  display: flex;
  gap: var(--space-lg);
}

.footer-legal a {
  color: var(--gray-300);
  text-decoration: none;
}

@media (max-width: 768px) {
  .trust-bar-container {
    grid-template-columns: repeat(2, 1fr);
  }

  .audience-grid,
  .process-grid {
    grid-template-columns: 1fr;
  }

  .about-grid {
    grid-template-columns: 1fr;
  }

  .hero-trust-list {
    flex-direction: column;
    align-items: center;
  }
}

`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA,0BAA0B;AAC1B;EACE,SAAS;EACT,UAAU;EACV,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,uBAAuB;EACvB,yBAAyB;EACzB,sBAAsB;EACtB,qBAAqB;EACrB,eAAe;EACf,qBAAqB;EACrB,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,mBAAmB;EACnB,mBAAmB;EACnB,mBAAmB;EACnB,mBAAmB;EACnB,mBAAmB;EACnB,mBAAmB;;EAEnB,eAAe;EACf,0FAA0F;EAC1F,qDAAqD;;EAErD,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,iBAAiB;;EAEjB,YAAY;EACZ,0CAA0C;EAC1C,6EAA6E;EAC7E,+EAA+E;EAC/E,gFAAgF;;EAEhF,kBAAkB;EAClB,qBAAqB;EACrB,mBAAmB;EACnB,oBAAoB;EACpB,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA,wBAAwB;;AAExB;EACE,gCAAgC;EAChC,gBAAgB;EAChB,sBAAsB;EACtB,8FAA8F;EAC9F,iBAAiB;EACjB,SAAS;EACT,UAAU;EACV,kBAAkB;AACpB;;AAEA,iBAAiB;AACjB;EACE,gBAAgB;EAChB,UAAU;EACV,8BAA8B;AAChC;;AAEA,0BAA0B;AAC1B;EACE,uFAAuF;EACvF,mBAAmB;EACnB,yCAAyC;EACzC,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,mDAAyV;EACzV,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,8BAA8B;EAC9B,4EAA4E;EAC5E,6BAA6B;EAC7B,oCAAoC;EACpC,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,8BAA8B;EAC9B,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,oBAAoB;EACpB,uBAAuB;EACvB,eAAe;EACf,2BAA2B;AAC7B;;AAEA;EACE,iBAAiB;EACjB,wCAAwC;AAC1C;;AAEA;EACE,uBAAuB;EACvB,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,wBAAwB;EACxB,0BAA0B;AAC5B;;AAEA,qBAAqB;AACrB;EACE,yCAAyC;EACzC,wBAAwB;AAC1B;;AAEA;EACE,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;EACtB,8BAA8B;AAChC;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,sBAAsB;EACtB,+BAA+B;EAC/B,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,oBAAoB;EACpB,4BAA4B;AAC9B;;AAEA;EACE,wBAAwB;EACxB,iCAAiC;EACjC,+BAA+B;EAC/B,wBAAwB;EACxB,kBAAkB;EAClB,yBAAyB;EACzB,4BAA4B;EAC5B,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,WAAW;EACX,4EAA4E;EAC5E,oBAAoB;EACpB,+BAA+B;AACjC;;AAEA;EACE,2BAA2B;EAC3B,4BAA4B;EAC5B,gCAAgC;AAClC;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,eAAe;EACf,8BAA8B;EAC9B,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;EACtB,8BAA8B;AAChC;;AAEA;EACE,sBAAsB;EACtB,gBAAgB;EAChB,SAAS;AACX;;AAEA,qBAAqB;AACrB;EACE,yCAAyC;EACzC,0BAA0B;AAC5B;;AAEA;EACE,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,oBAAoB;EACpB,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,oBAAoB;EACpB,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,4EAA4E;EAC5E,+BAA+B;EAC/B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,8BAA8B;AAChC;;AAEA;EACE,sBAAsB;EACtB,gBAAgB;EAChB,SAAS;AACX;;AAEA,gBAAgB;AAChB;EACE,yCAAyC;EACzC,4EAA4E;EAC5E,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,8BAA8B;AAChC;;AAEA;EACE,iBAAiB;EACjB,8BAA8B;EAC9B,YAAY;AACd;;AAEA;EACE,wBAAwB;EACxB,yBAAyB;EACzB,iBAAiB;EACjB,wCAAwC;AAC1C;;AAEA;EACE,2BAA2B;EAC3B,yBAAyB;AAC3B;;AAEA,eAAe;AACf;EACE,4EAA4E;EAC5E,mBAAmB;EACnB,wCAAwC;EACxC,+BAA+B;EAC/B,qBAAqB;EACrB,gBAAgB;EAChB,iBAAiB;EACjB,yBAAyB;EACzB,4BAA4B;EAC5B,YAAY;EACZ,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,2BAA2B;EAC3B,4BAA4B;EAC5B,mBAAmB;AACrB;;AAEA,sBAAsB;AACtB;EACE;IACE,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,sBAAsB;IACtB,mBAAmB;EACrB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,0BAA0B;IAC1B,oBAAoB;EACtB;;EAEA;IACE,0BAA0B;EAC5B;AACF;;AAEA;EACE;IACE,wCAAwC;EAC1C;;EAEA;IACE,eAAe;EACjB;;EAEA;;;IAGE,wCAAwC;EAC1C;;EAEA;IACE,wBAAwB;EAC1B;AACF;;AAEA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,wBAAwB;EACxB,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,eAAe;EACf,uBAAuB;EACvB,oBAAoB;EACpB,2BAA2B;EAC3B,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,wBAAwB;AAC1B;;AAEA;EACE,wBAAwB;EACxB,wCAAwC;EACxC,wBAAwB;AAC1B;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,aAAa;EACb,qCAAqC;EACrC,oBAAoB;EACpB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;EACtB,8BAA8B;AAChC;;AAEA;EACE,sBAAsB;EACtB,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,4EAA4E;EAC5E,+BAA+B;EAC/B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,mCAAmC;EACnC,cAAc;AAChB;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,oBAAoB;EACpB,4BAA4B;AAC9B;;AAEA;EACE,0BAA0B;EAC1B,iCAAiC;EACjC,+BAA+B;EAC/B,wBAAwB;AAC1B;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,8BAA8B;AAChC;;AAEA;EACE,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,yCAAyC;EACzC,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,oBAAoB;EACpB,4BAA4B;AAC9B;;AAEA;EACE,kBAAkB;EAClB,wBAAwB;EACxB,wBAAwB;EACxB,iCAAiC;EACjC,+BAA+B;AACjC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,4EAA4E;EAC5E,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;EACjB,gBAAgB;EAChB,mCAAmC;AACrC;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;EACtB,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;EACtB,8BAA8B;EAC9B,2BAA2B;AAC7B;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,UAAU;AACZ;;AAEA;EACE,0BAA0B;EAC1B,sBAAsB;EACtB,kBAAkB;EAClB,6BAA6B;AAC/B;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,OAAO;EACP,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,wBAAwB;EACxB,wBAAwB;EACxB,iCAAiC;EACjC,+BAA+B;AACjC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,iBAAiB;EACjB,sBAAsB;AACxB;;AAEA;EACE,qBAAqB;EACrB,2BAA2B;EAC3B,iBAAiB;EACjB,wCAAwC;AAC1C;;AAEA;EACE,wBAAwB;EACxB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,oBAAoB;AACtB;;AAEA;EACE,sBAAsB;EACtB,qBAAqB;AACvB;;AAEA;EACE;IACE,qCAAqC;EACvC;;EAEA;;IAEE,0BAA0B;EAC5B;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,sBAAsB;IACtB,mBAAmB;EACrB;AACF","sourcesContent":["/* Reset and Base Styles */\n* {\n  margin: 0;\n  padding: 0;\n  box-sizing: border-box;\n}\n\n:root {\n  /* Color Palette */\n  --primary-blue: #0f172a;\n  --secondary-blue: #1e293b;\n  --accent-blue: #3b82f6;\n  --light-blue: #60a5fa;\n  --teal: #14b8a6;\n  --light-teal: #5eead4;\n  --white: #ffffff;\n  --gray-50: #f8fafc;\n  --gray-100: #f1f5f9;\n  --gray-200: #e2e8f0;\n  --gray-300: #cbd5e1;\n  --gray-600: #475569;\n  --gray-700: #334155;\n  --gray-800: #1e293b;\n  --gray-900: #0f172a;\n  \n  /* Typography */\n  --font-primary: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;\n  --font-mono: 'JetBrains Mono', 'Fira Code', monospace;\n  \n  /* Spacing */\n  --space-xs: 0.5rem;\n  --space-sm: 1rem;\n  --space-md: 1.5rem;\n  --space-lg: 2rem;\n  --space-xl: 3rem;\n  --space-2xl: 4rem;\n  \n  /* Shadows */\n  --shadow-sm: 0 1px 2px 0 rgb(0 0 0 / 0.05);\n  --shadow-md: 0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1);\n  --shadow-lg: 0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1);\n  --shadow-xl: 0 20px 25px -5px rgb(0 0 0 / 0.1), 0 8px 10px -6px rgb(0 0 0 / 0.1);\n  \n  /* Border Radius */\n  --radius-sm: 0.375rem;\n  --radius-md: 0.5rem;\n  --radius-lg: 0.75rem;\n  --radius-xl: 1rem;\n  --radius-2xl: 1.5rem;\n}\n\n/* Import Google Fonts */\n\n.App {\n  font-family: var(--font-primary);\n  line-height: 1.6;\n  color: var(--gray-700);\n  background: linear-gradient(135deg, var(--gray-50) 0%, var(--white) 50%, var(--gray-100) 100%);\n  min-height: 100vh;\n  margin: 0;\n  padding: 0;\n  overflow-x: hidden;\n}\n\n/* Main Content */\nmain {\n  margin-top: 80px;\n  padding: 0;\n  min-height: calc(100vh - 80px);\n}\n\n/* Common Section Styles */\n.hero-section {\n  background: linear-gradient(135deg, var(--primary-blue) 0%, var(--secondary-blue) 100%);\n  color: var(--white);\n  padding: var(--space-2xl) var(--space-lg);\n  text-align: center;\n  position: relative;\n  overflow: hidden;\n}\n\n.hero-section::before {\n  content: '';\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: url('data:image/svg+xml,<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 100 100\"><defs><pattern id=\"grid\" width=\"10\" height=\"10\" patternUnits=\"userSpaceOnUse\"><path d=\"M 10 0 L 0 0 0 10\" fill=\"none\" stroke=\"rgba(255,255,255,0.05)\" stroke-width=\"0.5\"/></pattern></defs><rect width=\"100\" height=\"100\" fill=\"url(%23grid)\"/></svg>');\n  opacity: 0.3;\n}\n\n.hero-content {\n  max-width: 800px;\n  margin: 0 auto;\n  position: relative;\n  z-index: 1;\n}\n\n.hero-title {\n  font-size: 3.5rem;\n  font-weight: 800;\n  margin-bottom: var(--space-lg);\n  background: linear-gradient(135deg, var(--white) 0%, var(--light-teal) 100%);\n  -webkit-background-clip: text;\n  -webkit-text-fill-color: transparent;\n  background-clip: text;\n  line-height: 1.1;\n}\n\n.hero-subtitle {\n  font-size: 1.25rem;\n  margin-bottom: var(--space-xl);\n  color: var(--gray-300);\n  font-weight: 400;\n}\n\n.hero-cta {\n  display: flex;\n  gap: var(--space-md);\n  justify-content: center;\n  flex-wrap: wrap;\n  margin-top: var(--space-xl);\n}\n\n.hero-cta .cta-button {\n  font-size: 1.1rem;\n  padding: var(--space-md) var(--space-xl);\n}\n\n.hero-cta .cta-button.secondary {\n  background: transparent;\n  border: 2px solid var(--white);\n  color: var(--white);\n}\n\n.hero-cta .cta-button.secondary:hover {\n  background: var(--white);\n  color: var(--primary-blue);\n}\n\n/* Services Section */\n.services-section {\n  padding: var(--space-2xl) var(--space-lg);\n  background: var(--white);\n}\n\n.services-container {\n  max-width: 1200px;\n  margin: 0 auto;\n}\n\n.section-title {\n  text-align: center;\n  font-size: 2.5rem;\n  font-weight: 700;\n  color: var(--gray-900);\n  margin-bottom: var(--space-lg);\n}\n\n.section-subtitle {\n  text-align: center;\n  font-size: 1.1rem;\n  color: var(--gray-600);\n  margin-bottom: var(--space-2xl);\n  max-width: 600px;\n  margin-left: auto;\n  margin-right: auto;\n}\n\n.services-grid {\n  display: grid;\n  grid-template-columns: repeat(2, 1fr);\n  gap: var(--space-xl);\n  margin-top: var(--space-2xl);\n}\n\n.service-card {\n  background: var(--white);\n  border: 1px solid var(--gray-200);\n  border-radius: var(--radius-xl);\n  padding: var(--space-xl);\n  text-align: center;\n  transition: all 0.3s ease;\n  box-shadow: var(--shadow-sm);\n  position: relative;\n  overflow: hidden;\n}\n\n.service-card::before {\n  content: '';\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  height: 4px;\n  background: linear-gradient(135deg, var(--accent-blue) 0%, var(--teal) 100%);\n  transform: scaleX(0);\n  transition: transform 0.3s ease;\n}\n\n.service-card:hover {\n  transform: translateY(-8px);\n  box-shadow: var(--shadow-xl);\n  border-color: var(--accent-blue);\n}\n\n.service-card:hover::before {\n  transform: scaleX(1);\n}\n\n.service-icon {\n  font-size: 3rem;\n  margin-bottom: var(--space-lg);\n  display: block;\n}\n\n.service-card h3 {\n  font-size: 1.5rem;\n  font-weight: 600;\n  color: var(--gray-900);\n  margin-bottom: var(--space-md);\n}\n\n.service-card p {\n  color: var(--gray-600);\n  line-height: 1.6;\n  margin: 0;\n}\n\n/* Features Section */\n.features-section {\n  padding: var(--space-2xl) var(--space-lg);\n  background: var(--gray-50);\n}\n\n.features-container {\n  max-width: 1200px;\n  margin: 0 auto;\n}\n\n.features-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));\n  gap: var(--space-xl);\n  max-width: 1200px;\n  margin: 0 auto;\n}\n\n.feature-item {\n  display: flex;\n  gap: var(--space-md);\n  align-items: flex-start;\n}\n\n.feature-icon {\n  width: 48px;\n  height: 48px;\n  background: linear-gradient(135deg, var(--accent-blue) 0%, var(--teal) 100%);\n  border-radius: var(--radius-lg);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: var(--white);\n  font-size: 1.5rem;\n  flex-shrink: 0;\n}\n\n.feature-content h4 {\n  font-size: 1.25rem;\n  font-weight: 600;\n  color: var(--gray-900);\n  margin-bottom: var(--space-xs);\n}\n\n.feature-content p {\n  color: var(--gray-600);\n  line-height: 1.6;\n  margin: 0;\n}\n\n/* CTA Section */\n.cta-section {\n  padding: var(--space-2xl) var(--space-lg);\n  background: linear-gradient(135deg, var(--accent-blue) 0%, var(--teal) 100%);\n  color: var(--white);\n  text-align: center;\n}\n\n.cta-content {\n  max-width: 600px;\n  margin: 0 auto;\n}\n\n.cta-content h2 {\n  font-size: 2.5rem;\n  font-weight: 700;\n  margin-bottom: var(--space-lg);\n}\n\n.cta-content p {\n  font-size: 1.1rem;\n  margin-bottom: var(--space-xl);\n  opacity: 0.9;\n}\n\n.cta-content .cta-button {\n  background: var(--white);\n  color: var(--accent-blue);\n  font-size: 1.1rem;\n  padding: var(--space-md) var(--space-xl);\n}\n\n.cta-content .cta-button:hover {\n  background: var(--gray-100);\n  color: var(--accent-blue);\n}\n\n/* CTA Button */\n.cta-button {\n  background: linear-gradient(135deg, var(--accent-blue) 0%, var(--teal) 100%);\n  color: var(--white);\n  padding: var(--space-sm) var(--space-lg);\n  border-radius: var(--radius-lg);\n  text-decoration: none;\n  font-weight: 600;\n  font-size: 0.9rem;\n  transition: all 0.3s ease;\n  box-shadow: var(--shadow-md);\n  border: none;\n  cursor: pointer;\n  display: inline-block;\n}\n\n.cta-button:hover {\n  transform: translateY(-2px);\n  box-shadow: var(--shadow-lg);\n  color: var(--white);\n}\n\n/* Responsive Design */\n@media (max-width: 768px) {\n  .hero-title {\n    font-size: 2.5rem;\n  }\n  \n  .hero-subtitle {\n    font-size: 1.1rem;\n  }\n  \n  .hero-cta {\n    flex-direction: column;\n    align-items: center;\n  }\n  \n  .section-title {\n    font-size: 2rem;\n  }\n  \n  .services-grid {\n    grid-template-columns: 1fr;\n    gap: var(--space-lg);\n  }\n  \n  .features-grid {\n    grid-template-columns: 1fr;\n  }\n}\n\n@media (max-width: 480px) {\n  .hero-section {\n    padding: var(--space-xl) var(--space-md);\n  }\n  \n  .hero-title {\n    font-size: 2rem;\n  }\n  \n  .services-section,\n  .features-section,\n  .cta-section {\n    padding: var(--space-xl) var(--space-md);\n  }\n  \n  .service-card {\n    padding: var(--space-lg);\n  }\n}\n\n.hero-eyebrow {\n  display: inline-block;\n  font-size: 0.85rem;\n  font-weight: 600;\n  letter-spacing: 0.08em;\n  text-transform: uppercase;\n  color: var(--light-teal);\n  margin-bottom: var(--space-md);\n}\n\n.hero-trust-list {\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: center;\n  gap: var(--space-md);\n  margin-top: var(--space-xl);\n  color: var(--gray-300);\n  font-size: 0.95rem;\n}\n\n.hero-trust-list span {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.4rem;\n}\n\n.hero-trust-icon {\n  width: 18px;\n  height: 18px;\n  color: var(--light-teal);\n}\n\n.trust-bar {\n  background: var(--white);\n  border-bottom: 1px solid var(--gray-200);\n  padding: var(--space-lg);\n}\n\n.trust-bar-container {\n  max-width: 1200px;\n  margin: 0 auto;\n  display: grid;\n  grid-template-columns: repeat(4, 1fr);\n  gap: var(--space-lg);\n  text-align: center;\n}\n\n.trust-stat strong {\n  display: block;\n  font-size: 1.5rem;\n  font-weight: 700;\n  color: var(--gray-900);\n  margin-bottom: var(--space-xs);\n}\n\n.trust-stat span {\n  color: var(--gray-600);\n  font-size: 0.9rem;\n}\n\n.icon-box {\n  width: 56px;\n  height: 56px;\n  background: linear-gradient(135deg, var(--accent-blue) 0%, var(--teal) 100%);\n  border-radius: var(--radius-lg);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: var(--white);\n  margin: 0 auto var(--space-lg) auto;\n  flex-shrink: 0;\n}\n\n.feature-item .icon-box {\n  margin: 0;\n}\n\n.icon-svg {\n  display: block;\n}\n\n.icon-box .icon-svg {\n  width: 28px;\n  height: 28px;\n}\n\n.audience-grid {\n  display: grid;\n  grid-template-columns: repeat(3, 1fr);\n  gap: var(--space-xl);\n  margin-top: var(--space-2xl);\n}\n\n.audience-card {\n  background: var(--gray-50);\n  border: 1px solid var(--gray-200);\n  border-radius: var(--radius-xl);\n  padding: var(--space-xl);\n}\n\n.audience-card h3 {\n  font-size: 1.25rem;\n  font-weight: 600;\n  color: var(--gray-900);\n  margin-bottom: var(--space-sm);\n}\n\n.audience-card p {\n  color: var(--gray-600);\n  line-height: 1.6;\n}\n\n.process-section {\n  padding: var(--space-2xl) var(--space-lg);\n  background: var(--gray-50);\n}\n\n.process-grid {\n  display: grid;\n  grid-template-columns: repeat(3, 1fr);\n  gap: var(--space-xl);\n  margin-top: var(--space-2xl);\n}\n\n.process-step {\n  text-align: center;\n  padding: var(--space-xl);\n  background: var(--white);\n  border: 1px solid var(--gray-200);\n  border-radius: var(--radius-lg);\n}\n\n.step-number {\n  width: 60px;\n  height: 60px;\n  background: linear-gradient(135deg, var(--accent-blue) 0%, var(--teal) 100%);\n  color: var(--white);\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 1.5rem;\n  font-weight: 700;\n  margin: 0 auto var(--space-md) auto;\n}\n\n.process-step h4 {\n  font-size: 1.2rem;\n  font-weight: 600;\n  color: var(--gray-900);\n  margin-bottom: var(--space-sm);\n}\n\n.about-grid {\n  display: grid;\n  grid-template-columns: 2fr 1fr;\n  gap: var(--space-2xl);\n}\n\n.about-text h3 {\n  font-size: 1.5rem;\n  font-weight: 600;\n  color: var(--gray-900);\n  margin-bottom: var(--space-sm);\n  margin-top: var(--space-xl);\n}\n\n.about-text h3:first-child {\n  margin-top: 0;\n}\n\n.about-features {\n  list-style: none;\n  padding: 0;\n}\n\n.about-features li {\n  padding: var(--space-xs) 0;\n  color: var(--gray-600);\n  position: relative;\n  padding-left: var(--space-lg);\n}\n\n.about-features li::before {\n  content: '✓';\n  position: absolute;\n  left: 0;\n  color: var(--teal);\n  font-weight: bold;\n}\n\n.about-stats {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: var(--space-lg);\n}\n\n.stat-item {\n  text-align: center;\n  padding: var(--space-lg);\n  background: var(--white);\n  border: 1px solid var(--gray-200);\n  border-radius: var(--radius-lg);\n}\n\n.stat-number {\n  font-size: 2rem;\n  font-weight: 700;\n  color: var(--accent-blue);\n}\n\n.stat-label {\n  font-size: 0.9rem;\n  color: var(--gray-600);\n}\n\n.footer-cta-button {\n  display: inline-block;\n  margin-top: var(--space-sm);\n  font-size: 0.9rem;\n  padding: var(--space-sm) var(--space-md);\n}\n\n.footer-contact a {\n  color: var(--light-teal);\n  text-decoration: none;\n}\n\n.footer-legal {\n  display: flex;\n  gap: var(--space-lg);\n}\n\n.footer-legal a {\n  color: var(--gray-300);\n  text-decoration: none;\n}\n\n@media (max-width: 768px) {\n  .trust-bar-container {\n    grid-template-columns: repeat(2, 1fr);\n  }\n\n  .audience-grid,\n  .process-grid {\n    grid-template-columns: 1fr;\n  }\n\n  .about-grid {\n    grid-template-columns: 1fr;\n  }\n\n  .hero-trust-list {\n    flex-direction: column;\n    align-items: center;\n  }\n}\n\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
